import * as utils from '@utils/form';

export const FORM_FIELD = {
  MINISITE: {
    name: 'minisite',
    label: 'Choose a minisite:',
    rules: [{ required: true, message: 'Minisite is required' }],
    serialize: utils.makeRelatedEntitySerializer(['id', 'name']),
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  TITLE: {
    name: 'title',
    label: 'Add a title:',
    placeholder: 'Enter a title',
    rules: [{ required: true, message: 'Title is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Add a description:',
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.MINISITE.name]: [],
};
